<template>
    <!--Tab -->
    <div>
        <div class="tab-relacionado animated slideInUp">
            <ul class="nav nav-tabs "  >
                <!-- <li :class="(ofertasList.length > 0) ? 'active' : ''" style="border-radius: 0px;"><a data-toggle="tab" v-if="ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' ) " href="#ofertas">OFERTA</a></li> -->
                <li :class="(ofertasList.length == 0 && contactNews.length  > 0) ? 'active' : ''" style="border-radius: 0px;"><a data-toggle="tab" v-if="contactNews.length > 0  &&  (typeof contactNews !== 'undefined' ) " href="#noticias">NOTICIAS</a></li>
                <li :class="(contactNews.length == 0 && contactNewsE.length > 0) ? 'active' : ''"><a data-toggle="tab" href="#english"  v-if="contactNewsE.length > 0  &&  (typeof contactNewsE !== 'undefined' ) "  >ENGLISH NEWS</a></li>
                <li :class="(contactNews.length == 0 && contactVideosNew.length > 0) ? 'active' : ''"><a data-toggle="tab" href="#videos"  v-if="contactVideosNew.length > 0   &&  (typeof contactVideosNew !== 'undefined' ) " >VIDEOS</a></li>
            </ul>
            <div class="tab-content scroll-not">
                <!-- Tab Noticias -->
                <!-- <div id="ofertas" class="tab-pane fade"  :class="(ofertasList.length  >0) ? 'active in' : ''"  v-if="ofertasList  && ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' ) " >
                    <div class="row">
                        <div class="oferta" v-for="(tmpContNot,key,index) in ofertasList" v-if="ofertasList  && ofertasList.length > 0  &&  (typeof ofertasList !== 'undefined' )"  >
                            <div class="col-sm-6 divOfer" align="center">
                                <div class="img-ficha">
                                    <a target="_blank" :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" >
                                        <img :src="'https://images.produ.com/programas/'+tmpContNot.UbicacionFicha"  class="img-responsive imgOfer" >
                                    </a>
                                </div>
                                <div class="titulo-ficha">
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <h3><a :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" v-html="tmpContNot.Titulo" target="_blank" ></a></h3>
                                            <p v-html="tmpContNot.QtyEpisodios"></p>
                                        </div>
                                        <div class="col-sm-4 ficha-icon">
                                            <img src="../../assets/images/icon-ficha.png">
                                            <span><a :href="'http://especiales.produ.com/trailersingle/'+tmpContNot.IdEspecialTrailer+'/'+tmpContNot.IdPrograma" target="_blank">FICHA</a></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div align="center">
                        <ul class="pagination pagOfer">
                            <li :class="(currentPageNotOfer-1 == 0 ) ? 'disabled' : '' ">
                            <a @click.prevent="paginationOferta('prev',total_pagesNotOfer,currentPageNotOfer)"   >&laquo;</a></li>

                            <li v-for="value in total_pagesNotOfer"  :class="(currentPageNotOfer == value ) ? 'active' : '' "   v-if="resultSearchCounterNot>0 && ofertasList && (value<10+currentPageNotOfer  && value>=currentPageNotOfer )"    ><a    @click.prevent="currentPageNotOfer=value;pageNumNotOferta(currentPageNotOfer)" v-html="value"  ></a></li>
                            <li :class="(total_pagesNotOfer == currentPageNotOfer ) ? 'disabled' : '' "><a
                            @click.prevent="paginationOferta('next',total_pagesNotOfer,currentPageNotOfer)"  v-if="resultSearchCounterNotOfer>0 && ofertasList">&raquo;</a></li>
                        </ul>
                    </div>
                </div> -->

                <!-- Tab Noticias -->
                <div id="noticias" class="tab-pane fade"  :class="(ofertasList.length ==0 && contactNews.length >0) ? 'active in' : ''"  v-if="contactNews  && contactNews.length > 0  &&  (typeof contactNews !== 'undefined' ) " >
                    <div class="noticia" v-for="(tmpContNot,key,index) in contactNews" v-if="contactNews  && contactNews.length > 0  &&  (typeof contactNews !== 'undefined' )"  >
                        <div class="row">
                        <div class="col-sm-2" align="center">
                            <div class="imagen-tab-ne" >
                            <a target="_blank" :href="tmpContNot.permalink">
                                <div class="feat-image" :style="{ 'background-image': 'url('+ getImageUrl(tmpContNot.Image) +')' }" ></div>
                            </a>
                            </div>
                        </div>
                        <div class="col-sm-10">
                            <div class="info-tabs">
                            <a target="_blank" :href="tmpContNot.permalink"><h3 v-html="tmpContNot.Headline"></h3></a>
                            <p>{{  setDateFormat1ByLanguage('es', tmpContNot.Date )  }}</p>
                            </div>
                        </div>

                        </div>
                    </div>

                    <div align="center">
                        <ul class="pagination">
                            <li>
                                <a :readonly="currentPageNot <= 1" @click.prevent="currentPageNot = Math.max(1, currentPageNot-1); pageNumNot(currentPageNot)" >&laquo;</a>
                            </li>
                            <li v-if="total_pagesNot > 1 && currentPageNot > 3">
                                <a @click.prevent="currentPageNot=1;pageNumNot(1)">1</a>
                            </li>
                            <li v-if="currentPageNot > 4">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-for="value in total_pagesNot" :key="value"
                                v-if="resultSearchCounterNot>0 && contactNews && Math.abs(currentPageNot - value) <= 2"
                                :class="(currentPageNot == value ) ? 'active' : ''">
                                <a @click.prevent="currentPageNot=value;pageNumNot(value)" v-html="value"></a>
                            </li>
                            <li v-if="currentPageNot < total_pagesNot - 3">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-if="total_pagesNot > 1 && currentPageNot < total_pagesNot - 2">
                                <a @click.prevent="currentPageNot=total_pagesNot;pageNumNot(total_pagesNot)">{{ total_pagesNot }}</a>
                            </li>
                            <li>
                                <a :readonly="currentPageNot >= total_pagesNot" @click.prevent="currentPageNot = Math.min(total_pagesNot, currentPageNot+1); pageNumNot(currentPageNot)" >&raquo;</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Tab English -->
                <div id="english" class="tab-pane fade" :class="(contactNews.length ==0 && contactNewsE.length >0) ? 'active in' : '' "  v-if="contactNewsE.length > 0   &&  (typeof contactNewsE !== 'undefined' )" >
                    <div class="noticia" v-for="(tmpContNot,key,index) in contactNewsE" v-if="contactNewsE  && contactNewsE.length > 0  &&  (typeof contactNewsE !== 'undefined' )"  >
                        <div class="row">
                            <div class="col-sm-2" align="center">
                                <div class="imagen-tab-ne" >
                                <a target="_blank" :href="tmpContNot.permalink" >
                                    <div class="feat-image" :style="{ 'background-image': 'url(' + getImageUrl(tmpContNot.Image) + ')' }" ></div>
                                </a>
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="info-tabs">
                                <a target="_blank" :href="tmpContNot.permalink"><h3 v-html="tmpContNot.Headline"></h3></a>
                                <p>{{  setDateFormatEnglish(tmpContNot.Date )  }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div align="center">
                        <ul class="pagination">
                            <li>
                                <a :readonly="currentPageNotE <= 1" @click.prevent="currentPageNotE = Math.max(1, currentPageNotE-1); pageNumNotE(currentPageNotE)" >&laquo;</a>
                            </li>
                            <li v-if="total_pagesNotE > 1 && currentPageNotE > 3">
                                <a @click.prevent="currentPageNotE=1;pageNumNotE(1)">1</a>
                            </li>
                            <li v-if="currentPageNotE > 4">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-for="value in total_pagesNotE" :key="value"
                                v-if="resultSearchCounterNotE>0 && contactNewsE && Math.abs(currentPageNotE - value) <= 2"
                                :class="(currentPageNotE == value ) ? 'active' : ''">
                                <a @click.prevent="currentPageNotE=value;pageNumNotE(value)" v-html="value"></a>
                            </li>
                            <li v-if="currentPageNotE < total_pagesNotE - 3">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-if="total_pagesNotE > 1 && currentPageNotE < total_pagesNotE - 2">
                                <a @click.prevent="currentPageNotE=total_pagesNotE;pageNumNotE(total_pagesNotE)">{{ total_pagesNotE }}</a>
                            </li>
                            <li>
                                <a :readonly="currentPageNotE >= total_pagesNotE" @click.prevent="currentPageNotE = Math.min(total_pagesNotE, currentPageNotE+1); pageNumNotE(currentPageNotE)" >&raquo;</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Tab Video -->
                <div id="videos" class="tab-pane fade" :class="(contactNews.length ==0 && contactVideosNew.length >0) ? 'active in' : '' "   v-if="contactVideosNew && contactVideosNew.length > 0  &&  (typeof contactVideosNew !== 'undefined' )"  >
                    <div class="noticia" v-for="(tmpConVid,key,index) in contactVideosNew" v-if="contactVideosNew  && contactVideosNew.length > 0  &&  (typeof contactVideosNew !== 'undefined' )"  >
                        <div class="row">
                            <div class="col-sm-2" align="center">
                                <div class="imagen-tab-ne" >
                                    <a target="_blank" :href="tmpConVid.permalink">
                                        <div class="feat-image" :style="{ 'background-image': 'url(' + getImageUrl(tmpConVid.Image) + ')' }" ></div></a>
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="info-tabs">
                                    <a target="_blank" :href="tmpConVid.permalink"><h3 v-html="tmpConVid.Titulo"></h3></a>
                                    <p>{{  setDateFormat1ByLanguage('es', tmpConVid.Date )  }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div align="center">
                        <ul class="pagination">
                            <li>
                                <a :readonly="currentPageVideos <= 1" @click.prevent="currentPageVideos = Math.max(1, currentPageVideos-1); pageNumVid(currentPageVideos)" >&laquo;</a>
                            </li>
                            <li :class="(currentPageVideos == 1) ? 'active' : ''">
                                <a @click.prevent="currentPageVideos=1;pageNumVid(1)">1</a>
                            </li>
                            <li v-if="currentPageVideos > 4">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-for="value in total_pagesVideos" :key="value"
                                v-if="resultSearchCounterVideos>0 && contactVideosNew && value !== 1 && value !== total_pagesVideos && Math.abs(currentPageVideos - value) <= 2"
                                :class="(currentPageVideos == value ) ? 'active' : ''">
                                <a @click.prevent="currentPageVideos=value;pageNumVid(value)" v-html="value"></a>
                            </li>
                            <li v-if="currentPageVideos < total_pagesVideos - 3">
                                <span class="pagination-ellipsis">...</span>
                            </li>
                            <li v-if="total_pagesVideos > 1 && currentPageVideos < total_pagesVideos - 2">
                                <a @click.prevent="currentPageVideos=total_pagesVideos;pageNumVid(total_pagesVideos)" :class="(currentPageVideos == total_pagesVideos) ? 'active' : ''">{{ total_pagesVideos }}</a>
                            </li>
                            <li>
                                <a :readonly="currentPageVideos >= total_pagesVideos" @click.prevent="currentPageVideos = Math.min(total_pagesVideos, currentPageVideos+1); pageNumVid(currentPageVideos)" >&raquo;</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var resfulApi = 'https://backend.produ.com/admin/index.php/welcome/';

    import axios from 'axios';

    const flowBridgeAPIBase = process.env.FLOWBRIDGE_URL;

    export default {
        name: 'Content',
        props: {
            company: {
                type: [Object, Array],
                default: () => ({}),
            }
        },
        data() {
            return {
                contactNews: [],
                ofertasList: [],
                especialID: '',

                resultSearchCounterNot: 0,

                currentPageNot: 1,
                query_rowsNot: 10,
                total_pagesNot: 0,
                pageSizeNot: 10,
                pageNot: 1,
                total_pagesNotOfer: 0,

                contactNewsE: [],

                resultSearchCounterNotE: 0,
                resultSearchCounterNotOfer: 0,

                currentPageNotE: 1,
                currentPageNotOfer: 1,
                query_rowsNotE: 10,
                total_pagesNotE: 0,
                pageSizeNotE: 10,
                pageNotE: 1,

                contactVideosNew: [],

                resultSearchCounterVideos: 0,

                currentPageVideos: 1,
                query_rowsVideos: 10,
                total_pagesVideos: 0,
                pageSizeVideos: 10,
                pageVideos: 1,

                companyID: 0,
                defaultImage: require('@/assets/images/default-image.png'),
                imageCache: {},
            };
        },
        created() {},
        methods: {
            moment: function() {
                return moment();
            },
            getImageUrl: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '') {
                    return this.defaultImage;
                }

                // Si ya validamos esta URL, usar el resultado del cache
                if (this.imageCache.hasOwnProperty(imageUrl)) {
                    return this.imageCache[imageUrl];
                }

                // Por defecto retornar la URL original y validar en background
                this.validateImageInBackground(imageUrl);
                return imageUrl;
            },
            validateImageInBackground: function(imageUrl) {
                if (!imageUrl || imageUrl.trim() === '' || this.imageCache.hasOwnProperty(imageUrl)) {
                    return;
                }

                const img = new Image();

                img.onload = () => {
                    this.$set(this.imageCache, imageUrl, imageUrl);
                };

                img.onerror = () => {
                    // Marcar como error en cache
                    this.$set(this.imageCache, imageUrl, this.defaultImage);

                    // Actualizar todos los items que usan esta imagen
                    this.updateItemsWithFailedImage(imageUrl);
                };

                img.src = imageUrl;
            },
            updateItemsWithFailedImage: function(failedUrl) {
                // Actualizar imágenes en noticias español
                this.contactNews.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en noticias inglés
                this.contactNewsE.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });

                // Actualizar imágenes en videos
                this.contactVideosNew.forEach(item => {
                    if (item.Image === failedUrl) {
                        this.$set(item, 'Image', this.defaultImage);
                    }
                });
            },
            pageNumNot: async function(currPageIn) {

                await axios.get(flowBridgeAPIBase + 'posts/', {
                    params: {
                        company_id: this.company.id,
                        page: currPageIn,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterNot = 0;
                    this.total_pagesNot = 0;
                    this.contactNews = [];

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Headline: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        window.scrollTo(0, 0);
                        this.contactNews = normalized;
                        this.resultSearchCounterNot = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesNot = Math.ceil(this.resultSearchCounterNot / this.query_rowsNot);
                    }

                    this.$nextTick(function() {});
                });
            },
            getCompanyNoticiasWWFWS: async function(pageIN) {

                await axios.get(flowBridgeAPIBase + 'posts/', {
                    params: {
                        company_id: this.company.id,
                        language: 'es',
                        page: pageIN,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterNot = 0;
                    this.total_pagesNot = 0;
                    this.contactNews = [];

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Headline: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        this.contactNews = normalized;
                        this.resultSearchCounterNot = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesNot = Math.ceil(this.resultSearchCounterNot / this.query_rowsNot);
                    }

                    this.$nextTick(function() {});
                });
            },
            pageNumNotE: async function(currPageIn) {

                await axios.get(flowBridgeAPIBase + 'posts/', {
                    params: {
                        company_id: this.company.id,
                        language: 'en',
                        page: currPageIn,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterNotE = 0;
                    this.total_pagesNotE = 0;
                    this.contactNewsE = [];

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Headline: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        window.scrollTo(0, 0);
                        this.contactNewsE = normalized;
                        this.resultSearchCounterNotE = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesNotE = Math.ceil(this.resultSearchCounterNotE / this.query_rowsNotE);
                    }

                    this.$nextTick(function() {});
                });
            },
            getCompanyDataNotEWWFWS: async function(pageIN) {

                await axios.get(flowBridgeAPIBase + 'posts/', {
                    params: {
                        company_id: this.company.id,
                        language: 'en',
                        page: pageIN,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterNotE = 0;
                    this.total_pagesNotE = 0;
                    this.contactNewsE = [];

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Headline: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        this.contactNewsE = normalized;
                        this.resultSearchCounterNotE = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesNotE = Math.ceil(this.resultSearchCounterNotE / this.query_rowsNotE);
                    }

                    this.$nextTick(function() {});
                });
            },
            pageNumVid: async function(currPageIn) {

                await axios.get(flowBridgeAPIBase + 'videos/', {
                    params: {
                        company_id: this.company.id,
                        page: currPageIn,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterVideos = 0;
                    this.total_pagesVideos = 0;
                    this.contactVideosNew = [];
                    this.tabVideos = 1;

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Titulo: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        window.scrollTo(0, 0);
                        this.contactVideosNew = normalized;
                        this.totalRecordsContVids = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesVideos = Math.ceil(this.totalRecordsContVids / this.query_rowsVideos);
                    }

                    this.$nextTick(function() {});
                });
            },
            paginationNoticias: async function(
                direction,
                total_pagesNot,
                currentPageNot
            ) {
                if (direction == 'prev') {
                    currentPageNot - 1 == 0
                        ? ''
                        : this.pageNumNot(--this.currentPageNot);
                } else {
                    currentPageNot == total_pagesNot - 1
                        ? ''
                        : this.pageNumNot(++this.currentPageNot);
                }
            },
            paginationOferta: async function(
                direction,
                total_pagesNotOfer,
                currentPageNotOfer
            ) {
                if (direction == 'prev') {
                    currentPageNotOfer - 1 == 0
                        ? ''
                        : this.pageNumNotOferta(--this.currentPageNotOfer);
                } else {
                    currentPageNotOfer == total_pagesNotOfer
                        ? ''
                        : this.pageNumNotOferta(++this.currentPageNotOfer);
                }
            },
            get_VideosCompaniesWWFWS: async function(pageIN) {

                await axios.get(flowBridgeAPIBase + 'videos/', {
                    params: {
                        company_id: this.company.id,
                        page: pageIN,
                        limit: 10,
                        fields: 'featured_image'
                    }
                }).then(response => {
                    this.resultSearchCounterVideos = 0;
                    this.total_pagesVideos = 0;
                    this.contactVideosNew = [];
                    this.tabVideos = 1;

                    const feed = Array.isArray(response.data.data)
                        ? response.data.data
                        : response.data.result || [];

                    const normalized = feed.map(item => ({
                        Titulo: item.title,
                        HeadlineNumber: item.post_id,
                        Image: item.featured_image && item.featured_image.url ? item.featured_image.url : '',
                        Date: item.published_at,
                        permalink: item.permalink,
                    }));

                    if (response.data.total > 0 && response.data.data) {
                        this.contactVideosNew = normalized;
                        this.totalRecordsContVids = response.data.total;
                        // El cálculo correcto es solo Math.ceil, sin el if adicional
                        this.total_pagesVideos = Math.ceil(this.totalRecordsContVids / this.query_rowsVideos);
                    }

                    this.$nextTick(function() {});
                });
            },
            getOfertaByCompany: async function(contacID, pageIN) {
                this.contactID = contacID;

                await axios
                    .post(resfulApi + 'getOfertaByCompany', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        companyIN: this.contactID,
                        page: pageIN,
                    })
                    .then(response => {
                        this.resultSearch = [];
                        this.resultSearchCounter = 0;
                        this.total_pages = 0;
                        this.ofertasList = response.data.result;
                        this.especialID = response.data.IdEspecial;

                        if (
                            response.data.totalRecordsOfertas > 0 &&
                            response.data.result
                        ) {
                            this.resultSearchCounterNotOfer =
                                response.data.totalRecordsOfertas;

                            this.total_pagesNotOfer = Math.ceil(
                                this.resultSearchCounterNotOfer / this.query_rowsNot
                            );

                            if (
                                (this.resultSearchCounterNotOfer %
                                    this.query_rowsNot) %
                                this.query_rowsNot >
                                this.query_rowsNot
                            ) {
                                this.total_pagesNotOfer =
                                    this.total_pagesNotOfer + 1;
                            }
                        }

                        this.$nextTick(function() {});
                    });
            },
            pageNumNotOferta: async function(currPageIn) {
                await axios
                    .post(resfulApi + 'getOfertaByCompany', {
                        token:
                            'c6652c7ddcbd2074f0ebc142fbb1e6652c7ddcbd2074f0easdsad!@',
                        companyIN: this.contactID,
                        page: currPageIn,
                    })
                    .then(response => {
                        this.resultSearch = [];
                        this.resultSearchCounter = 0;
                        this.total_pages = 0;
                        this.ofertasList = response.data.result;
                        this.especialID = response.data.IdEspecial;

                        if (
                            response.data.totalRecordsOfertas > 0 &&
                            response.data.result
                        ) {
                            window.scrollTo(0, 0);

                            this.resultSearchCounterNotOfer =
                                response.data.totalRecordsOfertas;

                            this.total_pagesNotOfer = Math.ceil(
                                this.resultSearchCounterNotOfer / this.query_rowsNot
                            );
                        }

                        this.$nextTick(function() {});
                    });
            },
        },
        beforeMount() {},
        mounted: function() {
            this.contactID = this.$route.params.empresa;

            this.getCompanyNoticiasWWFWS(1);
            this.getCompanyDataNotEWWFWS(1);
            this.get_VideosCompaniesWWFWS(1);
            // this.getOfertaByCompany(this.contactID, 1);
        },
        watch: {
            '$route.params.empresa'(newId, oldId) {
                this.contactID = newId;
                this.getCompanyNoticiasWWFWS(1);
                this.getCompanyDataNotEWWFWS(1);
                this.get_VideosCompaniesWWFWS(1);
                // this.getOfertaByCompany(this.contactID, 1);
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .media-body a {
        color: #4e4e4e;
    }
</style>



// WEBPACK FOOTER //
// src/components/company/Content.vue